import "@tensorflow/tfjs";
import * as tmImage from "@teachablemachine/image";
import ModelHandlerContract from "../abstractions/ModelHandlerContract";

// Implement a class that adheres to the contract
export class TeachableMachineHandler {
  modelRef = null;
  maxPredictionsRef = 0;
  constructor(publicUrl) {
    this.publicUrl = publicUrl;
    // Ensure the class adheres to the contract
    Object.keys(ModelHandlerContract).forEach((method) => {
      if (typeof this[method] !== typeof ModelHandlerContract[method]) {
        throw new Error(
          `TeachableMachineHandler is missing the required method: ${method}`
        );
      }
    });
  }

  async loadModel() {
    const URL = this.publicUrl + "/tm-my-image-model/";
    const modelURL = URL + "model.json";
    const metadataURL = URL + "metadata.json";

    this.modelRef = await tmImage.load(modelURL, metadataURL);
    this.maxPredictionsRef = this.modelRef.getTotalClasses();
  }

  async predict(canvas) {
    if (!this.modelRef) return;
    return await this.modelRef.predict(canvas);
  }

  getTotalClasses() {
    return this.maxPredictionsRef || 0;
  }
}

export default TeachableMachineHandler;
